"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _formatSeconds = require("@devsta/format-seconds"),
    _CommentAssetPreview = _interopRequireDefault(require("./CommentAssetPreview")),
    _ContentView = _interopRequireDefault(require("../../ContentView")),
    _UserProfile = _interopRequireDefault(require("../../../common/UserProfile")),
    _Replies = _interopRequireDefault(require("../../../common/Replies")),
    _CommentTitle = _interopRequireDefault(require("./CommentTitle")),
    _utils = require("../../../utils");

require("../styles/_comments-list.scss");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var UNKNOWN = "Unknown",
    getClipAssetId = (0, _lodash["default"])(function (clipId, clips) {
  var _ref = clips.find(function (_ref2) {
    var commentClipId = _ref2.clipId;
    return commentClipId === clipId;
  }) || {},
      assetId = _ref.assetId;

  return assetId ? assetId : null;
}),
    getFormattedTimestamp = (0, _lodash["default"])(function (timestamp) {
  return Number.isNaN(+timestamp) ? UNKNOWN : (0, _formatSeconds.getMinutes)(timestamp);
}),
    getVisibleComments = function getVisibleComments(comments, clips) {
  return comments.reduce(function (visibleComments, comment) {
    var parentId = comment.parentId,
        clipId = comment.clipId,
        assetId = comment.assetId,
        timestamp = comment.timestamp;
    if (parentId) return visibleComments;
    var commentAssetId = clipId && clips.length ? getClipAssetId(clipId, clips) : assetId;
    return commentAssetId ? [].concat((0, _toConsumableArray2["default"])(visibleComments), [_objectSpread({}, comment, {
      timestamp: timestamp,
      commentAssetId: commentAssetId
    })]) : visibleComments;
  }, []);
};

function CommentsList(_ref3) {
  var comments = _ref3.comments,
      className = _ref3.className,
      _ref3$clips = _ref3.clips,
      clips = void 0 === _ref3$clips ? [] : _ref3$clips,
      getUserColor = _ref3.getUserColor,
      getNumberComments = _ref3.getNumberComments,
      visibleComments = getVisibleComments(comments, clips),
      numberComments = visibleComments.length;
  return getNumberComments && getNumberComments(numberComments), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("comments-list", className)
  }, !numberComments && _react["default"].createElement("div", {
    className: "comments-list__empty"
  }, _react["default"].createElement("span", null, "No one has left any comments.")), visibleComments.map(function (comment, commentIndex) {
    var commentId = comment.commentId,
        content = comment.content,
        createdByUser = comment.createdByUser,
        replies = comment.children,
        assetIds = comment.assetIds,
        timestamp = comment.timestamp,
        commentAssetId = comment.commentAssetId,
        _getUser = (0, _utils.getUser)(createdByUser),
        userId = _getUser.userId,
        name = _getUser.name,
        imageUrl = _getUser.imageUrl,
        isUser = _getUser.isUser,
        _getUserColor = getUserColor({
      userId: userId
    }),
        color = _getUserColor.color,
        brightness = _getUserColor.brightness,
        numberReplies = replies && replies.length || 0;

    return _react["default"].createElement("div", {
      key: commentId,
      className: "comments-list__comment"
    }, _react["default"].createElement(_CommentAssetPreview["default"], {
      assetId: commentAssetId
    }), _react["default"].createElement("div", {
      className: "comments-list__comment__content-wrapper"
    }, _react["default"].createElement("div", {
      className: "comments-list__comment__content-wrapper__heading"
    }, _react["default"].createElement(_CommentTitle["default"], {
      color: color,
      brightness: brightness,
      assetId: commentAssetId,
      commentIndex: commentIndex
    }), _react["default"].createElement("p", {
      className: "comments-list__comment__content-wrapper__heading__time"
    }, getFormattedTimestamp(timestamp))), _react["default"].createElement(_ContentView["default"], {
      content: content,
      truncate: !0
    }), _react["default"].createElement("div", {
      className: "comments-list__comment__content-wrapper__footer"
    }, _react["default"].createElement(_UserProfile["default"], {
      imageUrl: imageUrl,
      color: color,
      name: name,
      isUser: isUser
    }), _react["default"].createElement(_Replies["default"], {
      numberReplies: numberReplies,
      assetIds: assetIds
    }))));
  }));
}

var _default = (0, _react.memo)(CommentsList);

exports["default"] = _default;